import axios from 'axios'
import { getEnvVariables } from 'helpers/getEnvVariables'
import { store } from '../store'
import { onLogout } from '../store'

const { REACT_APP_API_URL } = getEnvVariables()

const marvarApi = axios.create({
    baseURL: REACT_APP_API_URL || 'http://localhost:3000'
})

marvarApi.interceptors.request.use( config => {
    config.headers = {
        ...config.headers,
        'x-token': localStorage.getItem('token')
    }
    return config
}, error => {
  return Promise.reject(error);
});

marvarApi.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            localStorage.clear()
            store.dispatch(onLogout())
        }
        return Promise.reject(error)
    }
)

export default marvarApi